<template>
  <div class="x600">
    <!--           @vs-accept="submitTechnic"-->
    <vs-prompt
      :vs-title="'Teknik Servis Hızlı İşlemler #' + serviceId"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="removeTechnic"
      @vs-close="removeTechnic"
      :vs-active.sync="activePrompt"
      vs-accept-text="Onayla"
      @vs-accept="submitTechnic"
      :vs-is-valid="validateForm"
    >
      <div>
        <div class="vx-row mt-2 mr-10 ml-5 mb-5">
          <div class="vx-col md:w-3/5 w-full mt-5">
            <p>Servisten sorumlu personel</p>
            <v-select name="responsiblePersonnelSelection" v-model="responsiblePersonnel" placeholder="Lütfen seçiniz." v-validate="'required'" :options="personnelList" label="userName" class="w-full" :color="validateForm ? 'success' : 'danger'">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col md:w-2/5 w-full mt-12">
            <b><vs-checkbox v-model="allPersonnel" @input="FilterPersonnelList()">Tüm Personel</vs-checkbox></b>
          </div>
        </div>
        <div class="vx-row mt-10 mr-10 ml-10 mb-5">
          <p>Cihaz servis durumu</p>
          <v-select v-validate="'required'" name="serviceStatusSeleciton" v-model="serviceStatusModel" placeholder="Lütfen seçiniz." :options="serviceStatus" label="value" class="w-full" :color="validateForm ? 'success' : 'danger'">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-row mt-10 mr-10 ml-10 mb-5">
          <div class="vx-col w-full">
            <h6 class="w-full mb-0 mt-2">Önceki Notlar</h6>
            <span id="lblNotes" disabled="disabled" class="w-full mb-0 mt-0" placeholder="Önceki Notlar"></span>
          </div>
        </div>
        <div class="vx-row mt-10 mr-10 ml-10 mb-5">
          <div class="vx-col w-full">
            <h6 class="w-full mb-0 mt-2">Teknik Servis Notu</h6>
            <vs-textarea v-validate="'required'" class="w-full mb-0 mt-0" placeholder="Teknik Servis Notu" v-model="currentServiceNote" :color="validateForm ? 'success' : 'danger'" />
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  props: {
    assignedPopUpMenu: {
      type: Boolean,
      required: true,
    },
    serviceId: {
      type: Number,
      required: true,
    },
    neighbourList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      responsiblePersonnel: "",
      allPersonnel: false,
      serviceStatusModel: {},
      personnelList: [],
      serviceStatus: [],
      currentService: {},
      currentServiceNote: "",
      previousNotes: "",
    };
  },
  created() {
    this.personnelList = this.neighbourList;
    this.personnelList = this.personnelList.filter((p) => p.teamId == this.$store.state.userData.teamId);
    this.currentService.notes = { customer: "", technic: "" };
    this.getCurrentService();
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    activePrompt: {
      get() {
        return this.assignedPopUpMenu;
      },
      set(value) {
        this.$emit("hideAssignedPopup", value);
      },
    },
  },
  updated() {},
  methods: {
    getCurrentService: async function() {
      if (!(this.serviceId > 0)) {
        this.$vs.notify({
          title: "Hata",
          text: "Servis bilgisi alınamadı!",
          color: "primary",
        });
        this.loading = false;
        return;
      }
      let a = await repository
        .postEntity("technic/getOrders", {
          id: this.serviceId,
        })
        .then((r) => r.list)
        .then((r) => r[0]);
      a = repository.convertToJSON(a, "serviceNote");
      a = repository.convertToJSON(a, "nextStatus");
      if (typeof a.serviceNote != "object" || !a.serviceNote.customer || !a.serviceNote.technic) {
        a.serviceNote = { customer: "", technic: [] };
      }
      this.currentService = {
        serviceId: a.serviceId,
        currentStatus: a.serviceStatusId,
        nextStatuses: a.nextStatus,
        notes: a.serviceNote,
      };
      var c = this.$store.state.userData;
      if (c.role !== "Admin") {
        var d = this.neighbourList.find((x) => x.userId == c.userId);
        this.responsiblePersonnel = d;
      }
      this.serviceStatusModel = this.currentService.nextStatuses[0];
      this.serviceStatus = this.currentService.nextStatuses;
      this.beautifyServiceNotes(this.currentService, "notes");
    },
    beautifyServiceNotes(currentItem, prop) {
      this.previousNotes = "Müşteri: " + currentItem[prop].customer + "<br/><hr/>";
      if (Array.isArray(currentItem[prop].technic)) {
        let ctr = 1;
        for (var i = 0; i < currentItem[prop].technic.length; i++) {
          if (currentItem[prop].technic[i].trim().length > 0) {
            this.previousNotes += ctr + ". " + currentItem[prop].technic[i] + "<br/>";
            ctr++;
          }
        }
      } else {
        if (currentItem[prop].technic.trim().length > 0) this.previousNotes += ": 1. " + currentItem[prop].technic + "<br/>";
      }
      document.getElementById("lblNotes").innerHTML = this.previousNotes;
    },
    removeTechnic() {},
    isAllValid: async function() {
      return await this.$validator.validateAll();
    },

    FilterPersonnelList: async function() {
      if (this.allPersonnel) {
        console.log(this.allPersonnel);
        this.personnelList = this.neighbourList;
      } else {
        this.personnelList = this.personnelList.filter((p) => p.teamId == this.$store.state.userData.teamId);
        console.log(this.allPersonnel);
        //this.softwareProductList = this.currentItem.products.filter((r) => r.ProductType == "Software");
      }
    },
    postModel: async function(postModel) {
      postModel.serviceType = "Technic";
      let r = await repository.postEntity("Technic/assignUser", postModel);
      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Başarılı!",
          text: "Ekleme tamamlandı!",
        });
        return true;
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: "Bilinmeyen hata",
        });
      }
      return false;
    },
    submitTechnic: async function() {
      if (this.isAllValid()) {
        var a = this.currentService.notes;
        if (Array.isArray(a.technic)) {
          a.technic.push(this.currentServiceNote);
        } else {
          let x = [];
          if (a.technic.trim().length > 0) {
            x.push(a.technic.trim());
            a.technic = x;
          }
        }
        let postModel = {
          currentUser: 0,
          serviceId: this.serviceId,
          assignedTo: this.responsiblePersonnel.userId,
          status: this.serviceStatusModel.id,
          serviceNote: this.currentServiceNote,
          serviceType: "Technic",
        };
        repository.postEntity("Technic/assignUser", postModel).then((r) => {
          if (r.isSuccessful) {
            this.$vs.notify({
              color: "success",
              title: "Hızlı İşlem",
              text: "Atama işlemi başarılı!",
            });
          } else if (r.hasExceptionError) {
            this.$vs.notify({
              color: "danger",
              title: `${r.exceptionMessage}`,
              text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hızlı İşlem",
              text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
            });
          }
        });
        this.$emit("updateCompleted", this.$event, this.serviceId, this.serviceStatusModel.id);
      }
    },
  },
};
</script>
